import React from 'react';

export const Logo = ({ size = 'small' }) => {
    const isLarge = size === 'large';
    return (
        <div className="flex flex-col items-center">
            <div className="text-center">
                <h1 className={`${isLarge ? 'text-6xl' : 'text-2xl'} font-bold bg-gradient-to-br from-cyan-500 via-purple-700 to-pink-500 bg-clip-text text-transparent leading-none m-0`}>
                    TEST
                </h1>
                <p className={`${isLarge ? 'text-2xl tracking-[0.4em]' : 'text-xs tracking-[0.3em]'} font-normal bg-gradient-to-br from-cyan-500 via-purple-700 to-pink-500 bg-clip-text text-transparent m-0 pl-1`}>
                    SERIES
                </p>
            </div>
            <div className={`mt-1 px-2 py-0.5 rounded bg-brand-primary/10 border border-brand-primary/20`}>
                <span className={`${isLarge ? 'text-sm' : 'text-[10px]'} font-bold text-brand-primary tracking-widest uppercase`}>
                    By TutorsForum
                </span>
            </div>
        </div>
    );
};